import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import Button from '@material-ui/core/Button';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import TextField from '@material-ui/core/TextField';

import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import Divider from '@material-ui/core/Divider';

import {Typography} from '@material-ui/core';
import {
  // fetchUserAccount,
  // selectUsers,
  updatePassword,
  updateUser,
} from '../features/users/usersSlice';

const ColorButton = withStyles((theme) => ({
  root: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: '#D86D7E',
    color: '#FFF',
    '&:hover': {
      opacity: 0.9,
      backgroundColor: '#D86D7E',
    },
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  // #42494E; light blue
  // #131f47; dark blue
  // #ed5e9d; pink
  tabBar: {
    // backgroundColor: ' rgba(0, 0, 0, 0.08)',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    // alignItems: 'center',
    borderRadius: '10px',
    backgroundColor: '#FFF',
    padding: 0,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    padding: theme.spacing(1, 3, 2),
  },
  linkText: {
    fontSize: 16,
    display: 'flex',
    alignItems: 'center',
  },
  headerContainer: {
    margin: theme.spacing(2),
  },
  subHeader: {margin: theme.spacing(2), marginBottom: 0},
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: '#42494E',
    color: '#FFF',
  },
  tabContent: {
    display: 'flex',
    flexFlow: 'column nowrap',
    flexGrow: 1,
  },
  root: {
    display: 'flex',
  },
  indicator: {
    backgroundColor: '#42494E',
  },
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function Account(props) {
  const {userAccount, error, loading} = props;
  const classes = useStyles();

  let jwtToken = localStorage.getItem('coreToken');
  // let coreUser = localStorage.getItem('coreUser');

  const dispatch = useDispatch();

  //get user by username search
  // const {userAccount, error, loading} = useSelector(selectUsers);
  // useEffect(() => {
  //   dispatch(
  //     fetchUserAccount({
  //       query: `?name=${coreUser}`,
  //       token: jwtToken,
  //     })
  //   );
  // }, [dispatch]);

  const [username, setUsername] = useState(userAccount.username);
  const [password, setPassword] = useState('');
  const [firstName, setFirstName] = useState(userAccount.firstName);
  const [lastName, setLastName] = useState(userAccount.lastName);
  const [displayName, setDisplayName] = useState(userAccount.displayName);
  const [email, setEmail] = useState(userAccount.email);
  const [tel, setTel] = useState(userAccount.mobile);

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmError, setConfirmError] = useState('');

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const submitAccountUpdate = (event) => {
    event.preventDefault();
    const user = {
      username: username,
      firstName: firstName,
      lastName: lastName,
      displayName: displayName,
      email: email,
      mobile: tel,
    };

    dispatch(
      updateUser({
        token: jwtToken,
        id: userAccount.id,
        user: user,
      })
    );
  };

  const submitUpdatePassword = (event) => {
    event.preventDefault();
    const passwordUpdate = {
      oldPassword: password,
      newPassword: newPassword,
    };

    if (!validatePassword()) {
      setPasswordError('Invalid password');
    } else if (newPassword !== confirmPassword) {
      setConfirmError("Passwords don't match");
    } else {
      setPasswordError('');
      setConfirmError('');
      dispatch(
        updatePassword({
          id: userAccount.id,
          token: jwtToken,
          passwordUpdate: passwordUpdate,
        })
      );
    }
  };

  const validatePassword = () => {
    var conditions = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,15}$/;
    if (newPassword.match(conditions)) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Container className={classes.paper} component="main" maxWidth="md">
      {/* // <Container className={classes.paper} fixed> */}
      {loading === 'loaded' && (
        <Card elevation={4}>
          <AppBar className={classes.tabBar} position="static">
            <Tabs
              classes={{
                indicator: classes.indicator,
              }}
              value={value}
              onChange={handleChange}
              aria-label="Account Tabs"
            >
              <Tab label="General" {...a11yProps(0)} />
              <Tab label="Password" {...a11yProps(1)} />
            </Tabs>
          </AppBar>

          <Grid
            container
            role="tabpanel"
            hidden={value !== 0}
            id={`simple-tabpanel-${0}`}
            aria-labelledby={`simple-tab-${0}`}
          >
            {value === 0 && (
              <div className={classes.tabContent}>
                {/* <Grid className={classes.headerContainer}>
                  <Typography variant="h4">User Account Details</Typography>
                </Grid>
                <Divider /> */}
                {/* <Grid>
                <Typography className={classes.subHeader} variant="body1">
                  New password must be longer than 6 characters and contain at
                  least one number and one special character
                </Typography>
              </Grid> */}
                <form className={classes.form} onSubmit={submitAccountUpdate}>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space between"
                  >
                    <Grid item sm>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="firstName"
                        label="First Name"
                        name="firstName"
                        autoComplete="given-name"
                        defaultValue={userAccount ? userAccount.firstName : ''}
                        onChange={(e) => setFirstName(e.target.value)}
                        error={error}
                      />
                    </Grid>
                    <Grid item sm>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="lastName"
                        label="Last Name"
                        name="lastName"
                        autoComplete="family-name"
                        defaultValue={userAccount ? userAccount.lastName : ''}
                        onChange={(e) => setLastName(e.target.value)}
                        error={error}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space between"
                  >
                    <Grid item sm>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="Username"
                        name="username"
                        autoComplete="username"
                        defaultValue={userAccount ? userAccount.username : ''}
                        autoFocus
                        onChange={(e) => setUsername(e.target.value)}
                        error={error}
                      />
                    </Grid>
                    <Grid item sm>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="Display Name"
                        label="displayName"
                        name="displayName"
                        autoComplete="username"
                        defaultValue={
                          userAccount ? userAccount.displayName : ''
                        }
                        onChange={(e) => setDisplayName(e.target.value)}
                        error={error}
                      />
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space between"
                  >
                    <Grid item sm>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email"
                        name="email"
                        autoComplete="email"
                        defaultValue={userAccount ? userAccount.email : ''}
                        onChange={(e) => setEmail(e.target.value)}
                        error={error}
                      />
                    </Grid>
                    <Grid item sm>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="text"
                        label="Phone Number"
                        name="text"
                        autoComplete="tel"
                        defaultValue={userAccount ? userAccount.mobile : ''}
                        onChange={(e) => setTel(e.target.value)}
                        error={error}
                      />
                    </Grid>
                  </Grid>
                  <ColorButton type="submit" fullWidth variant="contained">
                    Save Changes
                  </ColorButton>
                </form>

                <Divider />
              </div>
            )}
          </Grid>
          <Grid
            container
            role="tabpanel"
            hidden={value !== 1}
            id={`simple-tabpanel-${1}`}
            aria-labelledby={`simple-tab-${1}`}
          >
            {value === 1 && (
              <div className={classes.tabContent}>
                <Grid className={classes.headerContainer}>
                  <Typography variant="h4">Update Password</Typography>
                </Grid>
                <Divider />
                <Grid>
                  <Typography className={classes.subHeader} variant="body1">
                    New password must be at least 8 characters and contain at
                    least one number and one special character
                  </Typography>
                </Grid>

                <form className={classes.form} onSubmit={submitUpdatePassword}>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    autoFocus
                    name="current-password"
                    label="Current Password"
                    type="password"
                    id="current-password"
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                    inputProps={{minLength: 8, maxLength: 99}}
                    // error={passwordError}
                    // helperText={passwordError ? passwordError : ''}
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="new-password"
                    label="New Password"
                    type="password"
                    id="new-password"
                    autoComplete="new-password"
                    inputProps={{minLength: 8, maxLength: 99}}
                    onChange={(e) => setNewPassword(e.target.value)}
                    error={passwordError}
                    helperText={passwordError ? passwordError : ''}
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="confirm-password"
                    label="Confirm Password"
                    type="password"
                    id="confirm-password"
                    inputProps={{minLength: 8, maxLength: 99}}
                    autoComplete="new-password"
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    error={confirmError}
                    helperText={confirmError ? confirmError : ''}
                  />
                  <ColorButton type="submit" fullWidth variant="contained">
                    Update Password
                  </ColorButton>
                </form>
              </div>
            )}
          </Grid>
        </Card>
      )}
    </Container>
  );
}
